// extracted by mini-css-extract-plugin
export default {"menu":"bH6uNJ","AboveLeft":"cH6uNJ","AboveRight":"dH6uNJ","BelowLeft":"eH6uNJ","BelowRight":"fH6uNJ"};